<template>
  <v-select
    v-model="modelValue"
    v-bind="$attrs"
    :error-messages="errorMessages"
    :hide-details="true"
    :data-vv-as="displayName"
    :data-vv-name="inputIdentifier"
    :id="`input_${inputIdentifier}`"
    :items="phoneItems"
    :label="displayName"
    :name="inputIdentifier"
    outline
    ref="select-phone-type"/>
</template>

<script>
import PhoneTypes from '@/constants/phone-types';
import InputCommonMixin from '@/mixins/InputCommonMixin';

export default {
  mixins: [InputCommonMixin],
  data() {
    return {
      phoneItems: [
        { text: PhoneTypes.mobile.display, value: PhoneTypes.mobile.value },
        { text: PhoneTypes.home.display, value: PhoneTypes.home.value },
        { text: PhoneTypes.work.display, value: PhoneTypes.work.value },
      ],
    };
  },
};
</script>
